/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from "react";
// import { toast } from "react-toastify";

// import * as IconsSVG from "../../../../assets/iconsSVG";
import { OrigemRequisicao } from "services/api/Etapas_Subetapas/subetapas-get";
import { getTotalItensRetorno } from "screens/leads/components/tableGrid/constants";
import { Context } from "../../../../context/Context";
// import axiosLead from "../../../../services/lead";
import * as Styles from "../../styles";

interface Props {
  icon: JSX.Element;
  background: string;
  color: string;
  number: string;
  text: string;
  // Versão curta da label, exibida em telas estreitas (opcional).
  textShort?: string;
  border?: string;
  type: string;
  idStatus?: number[];
  idEtapa?: string[];
  temperaturas?: any;
  // Percentual opcional exibido como badge ao lado do número (ex.: agendamentos).
  percentual?: number | null;
  percentColor?: string;
  // Quando informado, substitui a navegação padrão para /leads (ex.: abrir detalhes).
  onCustomClick?: () => void;
}

const Indicators: React.FC<Props> = ({
  icon,
  background,
  color,
  number,
  text,
  textShort,
  border,
  type,
  idStatus,
  idEtapa,
  temperaturas,
  percentual,
  percentColor,
  onCustomClick,
}) => {
  const { filters, setFilters } = useContext(Context);

  const buildFilterState = (specificFilter: Record<string, any>) => ({
    OrdenarPorRecentes: null,
    InicioIntervaloCadastroLead: null,
    FimIntervaloCadastroLead: null,
    InicioIntervaloTransferencia: null,
    FimIntervaloTransferencia: null,
    FiltrarRecebidosPorTransferencia: null,
    OrigemRequisicao: OrigemRequisicao.Indicadores,
    ...specificFilter,
    paginationParams: {
      PaginaAtual: 1,
      PalavrasChave: "",
      TotalItensRetorno: getTotalItensRetorno(filters),
      OrdenarPorOrdemAlfabetica: "",
    },
  });

  const handleFilter = () => {
    // Cards de agendamento (Visita/Assinatura) não navegam para /leads — a ação
    // é definida por onCustomClick (ex.: abrir detalhes). Sem ele, não faz nada.
    if (type === "agendamento") return;

    let newFilters: any;

    switch (type) {
      case "status":
        newFilters = buildFilterState({ Status: idStatus });
        break;
      case "temperatura": {
        const found = temperaturas?.find((item: any) => item?.nome === text);
        newFilters = buildFilterState({
          IdsTemperaturasLead: found ? [found.id] : [""],
        });
        break;
      }
      case "etapa":
        newFilters = buildFilterState({ Etapas: idEtapa });
        break;
      default:
        break;
    }

    if (newFilters) {
      setFilters(newFilters);
      localStorage.setItem("@sell.it/leadFilters", JSON.stringify(newFilters));
    }
    window.location.href = "/leads?fromIndicator=true";
  };
  return (
    <Styles.CardIndicator
      style={{ background, border }}
      onClick={onCustomClick || handleFilter}
    >
      {icon}
      <Styles.NumberRow>
        <Styles.TextNumber color={color}>{number}</Styles.TextNumber>
        {percentual !== undefined && percentual !== null ? (
          <Styles.PercentBadge color={percentColor || color}>
            {percentual}%
          </Styles.PercentBadge>
        ) : null}
      </Styles.NumberRow>
      <Styles.TextStatus>
        {textShort ? (
          <>
            <span className="label-full">{text}</span>
            <span className="label-short">{textShort}</span>
          </>
        ) : (
          text
        )}
      </Styles.TextStatus>
    </Styles.CardIndicator>
  );
};
export default Indicators;
